import { Component, HostListener, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ParticlesComponent } from '@/app/shared/components/ui/particles/particles.component';
import { ThemeColorScheme } from '@/app/shared/models/theme.model';

@Component({
  standalone: true,
  selector: 'app-privacy-policy',
  imports: [CommonModule, ParticlesComponent],
  templateUrl: './privacy-policy.component.html',
  styleUrl: './privacy-policy.component.scss',
})
export class PrivacyPolicyComponent implements OnInit {
  isMobileMenuOpen = false;
  isDarkTheme = true;

  ngOnInit(): void {
    this.loadTheme();
  }

  toggleMobileMenu() {
    this.isMobileMenuOpen = !this.isMobileMenuOpen;
  }

  @HostListener('document:keydown.escape', ['$event'])
  onEscapeKey(event: KeyboardEvent) {
    if (this.isMobileMenuOpen) this.isMobileMenuOpen = false;
  }

  onThemeChange(isDarkMode: boolean) {
    this.isDarkTheme = isDarkMode;
  }

  private loadTheme() {
    const savedTheme = JSON.parse(localStorage.getItem('theme') || 'null');
    if (savedTheme) {
      this.isDarkTheme = savedTheme.colorScheme === ThemeColorScheme.DARK;
    } else {
      this.isDarkTheme = window.matchMedia(
        '(prefers-color-scheme: dark)',
      ).matches;
    }
    this.applyTheme();
  }

  private applyTheme() {
    const htmlElement = document.documentElement;
    if (this.isDarkTheme) {
      htmlElement.classList.add('dark');
      // localStorage.setItem('theme', 'dark');
    } else {
      htmlElement.classList.remove('dark');
      // localStorage.setItem('theme', 'light');
    }
  }
}


